import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Utils } from '../utils';
import { SeoResolution } from '../seo-page/seo-page.models';

@Injectable({ providedIn: 'root' })
export class SeoPageService {
  constructor(private readonly http: HttpClient) {}

  /** C06 full-path resolution; the only authority for whether an SEO path exists. */
  public resolve(path: string): Observable<SeoResolution> {
    const base = Utils.getApiUrl();
    return this.http.get<SeoResolution>(`${base}/seo-pages/resolve`, {
      params: new HttpParams().set('path', path),
    });
  }
}
